import * as tslib_1 from "tslib";
import { observable } from 'mobx';
export var defaultDocumentation = Object.freeze({
    description: '',
    note: '',
    package: '',
    isPackage: false,
    isConfiguration: false,
    script: '',
    tags: '',
    versionControlLink: ''
});
var Documentation = /** @class */ (function () {
    function Documentation(dto) {
        Object.assign(this, dto);
    }
    Documentation.prototype.update = function (key, value) {
        this[key] = value;
    };
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "description", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "note", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "package", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "isPackage", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "isConfiguration", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "script", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "tags", void 0);
    tslib_1.__decorate([
        observable
    ], Documentation.prototype, "versionControlLink", void 0);
    return Documentation;
}());
export { Documentation };



//////////////////
// WEBPACK FOOTER
// ./src/models/Documentation.ts
// module id = 743
// module chunks = 0